import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const TextoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TEXTO' htmlFor='input-texto' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='texto'>
          {({ field }) => (
            <Form.TextArea
              {...field}
              id='input-texto'
              rows={4}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TextoFormGroup)
